<template>
    <div class="main">
        <sub-title
            title="企业介绍"
            class="title"
        ></sub-title>
        <div class="content" :style="{height: webInfo.id == 'hzyc' ?'340px' : '412px'}">
            <div class="left-part" v-if="webInfo.about.qyjs.showLeftVideo">
                <div
                    class="video-placeholder"
                    v-show="pauseState"
                    @click="playHandler"
                >
                    <img :src="mydata.img1" />

                    <img
                        class="icon-play"
                        :src="mydata.img2"
                        alt=""
                    />
                </div>

                <video
                    ref="video"
                    v-show="!pauseState"
                    class="video"
                    :src="mydata.videoUrl"
                    controls
                ></video>
            </div>
            <div class="right-part">
                <div class="sub-title">{{mydata.title}}</div>
                <div class="text">
                    <p v-for="(item,i) in mydata.rightList" :key="i">
                        &nbsp;&nbsp; {{item}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubTitle from './sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
            pauseState: true,
        };
    },
    created() {},
    methods: {
        playHandler() {
            this.pauseState = false;
            this.$refs.video.play();
        },
    },
    mounted() {},
    computed: {
        mydata(){
            return this.webInfo.about.qyjs
        },
    },
};
</script>
<style scoped lang="scss">
.main {
    padding-bottom: 20px;

    .title {
        margin-bottom: 47px;
    }
}

.content {
    background: #fff;
    box-shadow: 0px 17px 44px 0px rgba(0, 0, 0, 0.09);
    padding: 13px 11px;
    display: flex;

    .left-part {
        width: 600px;
        .video-placeholder {
            width: 573px;
            height: 387px;
            position: relative;
            cursor: pointer;

            .icon-play {
                width: 60px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                opacity: 0.6;
                transition: all 0.3s;
            }

            &:hover {
                .icon-play {
                    opacity: 0.9;
                }
            }
        }

        .video {
            width: 573px;
            height: 387px;
        }
    }

    .right-part {
        padding: 0px 10px 10px 22px;
        .sub-title {
            font-size: 18px;
            text-align: center;
            line-height: 35px;
            color: #131415;
        }
        .text {
            font-size: 15px;
            line-height: 29px;
            color: #333333;
            text-indent: 20px;

            p {
                &:not(:last-child) {
                    margin-bottom: 44px;
                }
            }
        }
    }
}
</style>
